import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React from 'react';
import ClauseInput from "../ClauseInput";
import { _ClauseGroupWrapper } from "../ClauseGroup/style";
var ClauseRow = function ClauseRow(_ref) {
  var apiConditionResourcesAttributes = _ref.apiConditionResourcesAttributes,
    conditionResourcesOptions = _ref.conditionResourcesOptions,
    conditionModalVisible = _ref.conditionModalVisible,
    disabledUpdateCondition = _ref.disabledUpdateCondition,
    fields = _ref.fields,
    handleAddAndClause = _ref.handleAddAndClause,
    error = _ref.meta.error;
  return /*#__PURE__*/React.createElement(_ClauseGroupWrapper, {
    flexDirection: "column"
  }, fields.map(function (clause, index) {
    return /*#__PURE__*/React.createElement(ClauseInput, {
      apiConditionResourcesAttributes: apiConditionResourcesAttributes,
      clause: clause,
      conditionResourcesOptions: conditionResourcesOptions,
      conditionModalVisible: conditionModalVisible,
      disabledUpdateCondition: disabledUpdateCondition,
      fields: fields,
      handleAddAndClause: handleAddAndClause,
      index: index,
      key: index
    });
  }), error && /*#__PURE__*/React.createElement("li", {
    className: "error"
  }, error));
};
export default ClauseRow;